import { ActionType } from "../types";
import { UserSettings, UserSettingsAction } from "../types/user_settings";

export const user_settings = (
  state: UserSettings = null,
  action: UserSettingsAction
): UserSettings => {
  switch (action.type) {
    case ActionType.GET_USER_SETTINGS_SUCCESS:
    case ActionType.UPDATE_USER_SETTINGS_SUCCESS:
      return action.settings
        ? {
            ...action.settings,
          }
        : null;
    default:
      return state;
  }
};
